import React, { Component } from "react";
import { TextInput as NativeInput, StyleSheet, TouchableOpacity } from "react-native";

import FloatingLabel from './FloatingLabel';

export default class TextInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
      text: props.value,
      height: props.height
    };
  }
  focus() {
    this.refs.input.focus();
  }
  blur() {
    this.refs.input.blur();
  }
  isFocused() {
    return this.state.isFocused;
  }
  measureLayout(...args) {
    this.refs.wrapper.measureLayout(...args)
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.text !== nextProps.value) {
      this.setState({ text: nextProps.value });
    }
    if (this.props.height !== nextProps.height) {
      this.setState({ height: nextProps.height });
    }
  }
  render() {
    let {
      label,
      highlightColor,
      duration,
      labelColor,
      borderColor,
      textColor,
      textFocusColor,
      textBlurColor,
      onFocus,
      onBlur,
      onChangeText,
      onChange,
      value,
      dense,
      inputStyle,
      wrapperStyle,
      labelStyle,
      height,
      autoGrow,
      multiline,
      ...props
    } = this.props;

    return (
      <TouchableOpacity activeOpacity={1}
        onPress={() => {
          this.refs.input.focus()
        }}
        style={[multiline ? styles.multiwrapper : styles.wrapper, wrapperStyle]} ref="wrapper">
        <NativeInput
          testID={this.props.testID}
          editable={this.props.editable}
          style={[multiline ? styles.multitextInput : styles.textInput, {
            color: textColor
          }, (this.state.isFocused && textFocusColor) ? {
            color: textFocusColor
          } : null, (!this.state.isFocused && textBlurColor) ? {
            color: textBlurColor
          } : null, inputStyle, this.state.height ? { height: this.state.height } : null, this.props.borderColor != null ? { borderColor: borderColor } : null, { fontFamily: 'IRANSansMobile' }]}
          multiline={multiline}
          importantForAutofill='off'

          onFocus={() => {
            this.setState({ isFocused: true });
            // this.refs.floatingLabel.floatLabel();
            onFocus && onFocus();
          }}
          onBlur={() => {
            this.setState({ isFocused: false });
            // this.state.text != null && !this.state.text.length && this.refs.floatingLabel.sinkLabel();
            onBlur && onBlur();
          }}
          onChangeText={(text) => {
            this.setState({ text });
            onChangeText && onChangeText(text);
          }}
          onChange={(event) => {
            if (autoGrow) {
              this.setState({ height: event.nativeEvent.contentSize.height });
            }
            onChange && onChange(event);
          }}
          keyboardType={this.props.inputType}
          ref="input"
          value={this.state.text}
          {...props}
        />
        <FloatingLabel
          isFocused={this.state.isFocused}
          focusHandler={this.focus.bind(this)}
          label={label}
          labelColor={labelColor}
          highlightColor={highlightColor ? highlightColor : 'black'}
          duration={duration}
          dense={dense}
          hasValue={this.state.text != null && this.state.text.length > 0}
          style={labelStyle}
        />
      </TouchableOpacity>
    );
  }
}



TextInput.defaultProps = {
  duration: 200,
  labelColor: 'gray',
  borderColor: '#E0E0E0',
  highlightColor: 'white',
  textColor: 'black',
  value: '',
  dense: false,
  underlineColorAndroid: 'transparent',
  multiline: false,
  autoGrow: false,
  height: undefined
};

const styles = StyleSheet.create({
  wrapper: {
    height: 60,
    justifyContent: 'center',
    marginLeft: 10,
    marginTop: 5,
    marginRight: 10,
  },
  multiwrapper: {
    minHeight: 60,
    justifyContent: 'center',
    marginLeft: 10,
    marginTop: 5,
    marginRight: 10,
  },
  textInput: {
    fontSize: 14,
    minHeight: 40,
    borderWidth: 1,
    paddingLeft: 10,
    paddingRight: 10,
    color: 'gray',
    textAlign: 'right',
    outlineColor: 'transparent',
    outlineWidth: 0,
    borderColor: '#82a4c0',
    borderRadius: 5,
  },
  multitextInput: {
    fontSize: 14,
    minHeight: 40,
    paddingTop: 10,
    borderWidth: 1,
    paddingLeft: 15,
    paddingRight: 15,
    outlineColor: 'transparent',
    outlineWidth: 0,
    color: 'gray',
    textAlign: 'right',
    borderColor: '#82a4c0',
    borderRadius: 5,
  },
});
